import acronis_en_attributes from '../tenants/acronis/en/attributes.json';
import acronis_en_branding from '../tenants/acronis/en/branding.json';
import acronis_en_creator from '../tenants/acronis/en/creator.json';
import acronis_en_onboarding from '../tenants/acronis/en/onboarding.json';
import acronis_en_sidebar from '../tenants/acronis/en/sidebar.json';
import acronis_en_vibeCreator from '../tenants/acronis/en/vibeCreator.json';
import acronis_es_attributes from '../tenants/acronis/es/attributes.json';
import acronis_es_branding from '../tenants/acronis/es/branding.json';
import acronis_es_creator from '../tenants/acronis/es/creator.json';
import acronis_es_onboarding from '../tenants/acronis/es/onboarding.json';
import acronis_es_sidebar from '../tenants/acronis/es/sidebar.json';
import acronis_es_vibeCreator from '../tenants/acronis/es/vibeCreator.json';
import acronis_it_attributes from '../tenants/acronis/it/attributes.json';
import acronis_it_branding from '../tenants/acronis/it/branding.json';
import acronis_it_creator from '../tenants/acronis/it/creator.json';
import acronis_it_onboarding from '../tenants/acronis/it/onboarding.json';
import acronis_it_sidebar from '../tenants/acronis/it/sidebar.json';
import acronis_it_vibeCreator from '../tenants/acronis/it/vibeCreator.json';
import annamoney_en_creator from '../tenants/annamoney/en/creator.json';
import dentifai_en_creator from '../tenants/dentifai/en/creator.json';
import dentifai_es_creator from '../tenants/dentifai/es/creator.json';
import elliotgroup_en_creator from '../tenants/elliotgroup/en/creator.json';
import elliotgroup_es_creator from '../tenants/elliotgroup/es/creator.json';
import gohighlevel_en_creator from '../tenants/gohighlevel/en/creator.json';
import gohighlevel_es_creator from '../tenants/gohighlevel/es/creator.json';
import ionos_en_common from '../tenants/ionos/en/common.json';
import ionos_en_creator from '../tenants/ionos/en/creator.json';
import ionos_es_common from '../tenants/ionos/es/common.json';
import ionos_es_creator from '../tenants/ionos/es/creator.json';
import ionos_it_creator from '../tenants/ionos/it/creator.json';
import newo_en_attributes from '../tenants/newo/en/attributes.json';
import newo_en_creator from '../tenants/newo/en/creator.json';
import newo_es_attributes from '../tenants/newo/es/attributes.json';
import newo_es_creator from '../tenants/newo/es/creator.json';
import newo_it_attributes from '../tenants/newo/it/attributes.json';
import newo_it_creator from '../tenants/newo/it/creator.json';
import newo_agent_en_creator from '../tenants/newo_agent/en/creator.json';
import newo_agent_es_creator from '../tenants/newo_agent/es/creator.json';
import nextiva_en_creator from '../tenants/nextiva/en/creator.json';
import nextiva_en_home from '../tenants/nextiva/en/home.json';
import nextiva_es_creator from '../tenants/nextiva/es/creator.json';
import nextiva_es_home from '../tenants/nextiva/es/home.json';
import nextiva_it_home from '../tenants/nextiva/it/home.json';
import nextiva_partner_en_creator from '../tenants/nextiva_partner/en/creator.json';
import nextiva_partner_es_creator from '../tenants/nextiva_partner/es/creator.json';
import telebots_en_creator from '../tenants/telebots/en/creator.json';
import telebots_es_creator from '../tenants/telebots/es/creator.json';
import type { TranslationDictionary } from '../types';

export const tenantDictionaries: Record<
	string,
	Record<string, TranslationDictionary>
> = {
	acronis: {
		en: {
			attributes: acronis_en_attributes,
			branding: acronis_en_branding,
			creator: acronis_en_creator,
			onboarding: acronis_en_onboarding,
			sidebar: acronis_en_sidebar,
			vibeCreator: acronis_en_vibeCreator
		},
		es: {
			attributes: acronis_es_attributes,
			branding: acronis_es_branding,
			creator: acronis_es_creator,
			onboarding: acronis_es_onboarding,
			sidebar: acronis_es_sidebar,
			vibeCreator: acronis_es_vibeCreator
		},
		it: {
			attributes: acronis_it_attributes,
			branding: acronis_it_branding,
			creator: acronis_it_creator,
			onboarding: acronis_it_onboarding,
			sidebar: acronis_it_sidebar,
			vibeCreator: acronis_it_vibeCreator
		}
	},
	annamoney: {
		en: {
			creator: annamoney_en_creator
		}
	},
	dentifai: {
		en: {
			creator: dentifai_en_creator
		},
		es: {
			creator: dentifai_es_creator
		}
	},
	elliotgroup: {
		en: {
			creator: elliotgroup_en_creator
		},
		es: {
			creator: elliotgroup_es_creator
		}
	},
	gohighlevel: {
		en: {
			creator: gohighlevel_en_creator
		},
		es: {
			creator: gohighlevel_es_creator
		}
	},
	ionos: {
		en: {
			creator: ionos_en_creator,
			common: ionos_en_common
		},
		es: {
			creator: ionos_es_creator,
			common: ionos_es_common
		},
		it: {
			creator: ionos_it_creator
		}
	},
	newo: {
		en: {
			attributes: newo_en_attributes,
			creator: newo_en_creator
		},
		es: {
			attributes: newo_es_attributes,
			creator: newo_es_creator
		},
		it: {
			attributes: newo_it_attributes,
			creator: newo_it_creator
		}
	},
	newo_agent: {
		en: {
			attributes: newo_en_attributes,
			creator: newo_agent_en_creator
		},
		es: {
			attributes: newo_es_attributes,
			creator: newo_agent_es_creator
		}
	},
	nextiva: {
		en: {
			creator: nextiva_en_creator,
			home: nextiva_en_home
		},
		es: {
			creator: nextiva_es_creator,
			home: nextiva_es_home
		},
		it: {
			home: nextiva_it_home
		}
	},
	nextiva_partner: {
		en: {
			creator: nextiva_partner_en_creator
		},
		es: {
			creator: nextiva_partner_es_creator
		}
	},
	telebots: {
		en: {
			creator: telebots_en_creator
		},
		es: {
			creator: telebots_es_creator
		}
	}
};
